export default __webpack_public_path__ + "static/media/global-footprint.5d405d1f.jpg";